module.exports = __webpack_public_path__ + "static/media/super_pack_fr_hiver_chien.6a823742.png";